export default class VideoList {
    constructor() {
        this.setVideoControls();
    }
    setVideoControls(){
        let videoLists = $(document).find('.video-list');
        let t = this;
        videoLists.each((i,e) => {
            let $e = $(e);
            $e.find('.video-list-selection label').click((e)=>{t._activeVideoChange(e);});
        });
    }
    _activeVideoChange(e){
        let videoLabel = $(e.target.closest('label'));
        let videoList = videoLabel.closest('.video-list');
        let videoCheck = videoList.find('#'+videoLabel.attr('for'));
        let video = videoCheck.closest('div').find('video')[0];
        if(video.currentTime === 0 || video.paused || video.ended){
            videoList.find('video').not(video).each((i,v)=>{v.pause();v.currentTime=0;});
            video.play();
        }
    }
}


// WEBPACK FOOTER //
// ./public/js/VideoList.js